// Launch Darkly Keys for Order Solution
var FF_FULFILLMENT_TYPE_CURBSIDE = "FF-FULFILLMENT-TYPE-CURBSIDE";
var FF_FULFILLMENT_TYPE_DELIVERY = "FF-FULFILLMENT-TYPE-DELIVERY";
var FF_SHOW_FAVORITES = "FF-SHOW-FAVORITES";
var FF_VANITY_CODE_ENABLED = "FF-VANITY-CODE-ENABLED";
var FF_BEST_SELLERS_ENABLED = "FF_BEST_SELLERS_ENABLED";
var FF_MAINTENANCE_PAGE_REDIRECT = "FF-MAINTENANCE_PAGE_REDIRECT";
var FF_ENABLE_CUSTOM_BANNER = "FF-ENABLE-CUSTOM-BANNER";
var FF_COMBOS_BEFORE_AND_AFTER_PRICING = "FF-COMBOS_BEFORE_AND_AFTER_PRICING";

var FF_LOYALTY_MIGRATION = "FF-LOYALTY-MIGRATION";

var FF_FOOTLONG_DOUBLE_PROTEIN = "FF_FOOTLONG_DOUBLE_PROTEIN";
var FF_NEW_GIFTCARD_FORMAT = "FF-GIFT_CARD_PROVIDER";

var FF_ENABLE_UTENSILS = "FF_ENABLE_UTENSILS";
var FF_ENABLE_NONSDOFFERS = "FF-NONSD-CARDS";
var FF_ENABLE_SUBWAYMERCH = "FF-SUBWAYMERCH-CARD";
var FF_ENABLE_GIFTCARD = "FF-SHOW-GIFT-CARD";
var FF_APPLE_PAY_PAYMENT_METHOD_WEB = "FF-APPLE_PAY_PAYMENT_METHOD_WEB";
var FF_GOOGLE_PAY_PAYMENT_METHOD_WEB = "FF-GOOGLE_PAY_PAYMENT_METHOD_WEB";
var FF_FREEDOM_PAY = "FF_FREEDOM_PAY";
var FF_ATH_MOVIL = "FF_ATH_MOVIL";
var currentEnvID = $("#ldEnvKey").val(); // Get the current environment id from Web.config
var defaultEnvId = "62865413a65084143bda68a9";
var client;
var launchdarkly;

// Here we initialize the LaunchDarkly client connection.
function InitilizeLD() {
  if (client) {
    client.close();
  }

  var envId = currentEnvID || defaultEnvId;
  var context = constructUserObject();
  client = LDClient.initialize(envId, context);
  client.waitUntilReady().then(() => {
    client.on("change", function (allChanges) {
      let LDKey = Object.keys(allChanges)[0];
      if (LDKey == FF_MAINTENANCE_PAGE_REDIRECT)
        launchdarkly.ShowMaintenancePage(allChanges);
      if (LDKey == FF_SHOW_FAVORITES) launchdarkly.HideFavorites(allChanges);
      if (LDKey == FF_VANITY_CODE_ENABLED)
        launchdarkly.HideVanityCode(allChanges);
      if (LDKey == FF_BEST_SELLERS_ENABLED)
        launchdarkly.HideBestSellers(allChanges);
      if (LDKey == FF_ENABLE_CUSTOM_BANNER)
        launchdarkly.ShowCustomBanner(allChanges);
      if (LDKey == FF_LOYALTY_MIGRATION)
        launchdarkly.HideRewardsAndDeals(allChanges);
      if (LDKey == FF_FULFILLMENT_TYPE_DELIVERY)
        launchdarkly.HideFullfillmentTypeDelivery(allChanges);
    });
    client.waitForInitialization().then(function () {
      launchdarkly.HideFavorites();
      launchdarkly.HideBestSellers();
      launchdarkly.ShowMaintenancePage();
      launchdarkly.ShowCustomBanner();
      launchdarkly.HideRewardsAndDeals();
      launchdarkly.HideVanityCode();
    });
  });
}

// Here we build a user object from the form fields.
// https://docs.launchdarkly.com/home/users/built-in-attributes
// https://docs.launchdarkly.com/home/users/custom-attributes/?q=user
function constructUserObject() {
  let context = {
    kind: "user",
    key: "subway-WEB_" + $("#scLanguageCode").val().toLowerCase(),
    country: $("#scLanguageCode").val().slice(-2).toLowerCase(),
    culture: $("#scLanguageCode").val().toLowerCase(),
  };

  void 0;
  return context;
}

/*  NEW LD FLAG FUNCTION TEMPLATE
 
    Check for (Flag Type) Flag --> [Flag key]
    function Show(FlagType)() {
        var (FlagType)Flag = client.variation("[Flag key]", false);
        // Flag Logic
    }
 
    Documentation: https://docs.launchdarkly.com/sdk/features
 
*/

var LaunchDarkly = function () {
  // Check for Fullfillment Type Curbside flag --> [FF-FULFILLMENT-TYPE-CURBSIDE]
  this.HideFullfillmentTypeCurbside = function (changes) {
    let fullfillmentTypeCurbsideFlag = client.variation(
      FF_FULFILLMENT_TYPE_CURBSIDE,
      false
    );
  };

  // Check for Fullfillment Type Delivery flag --> [FF-FULFILLMENT-TYPE-DELIVERY]
  this.HideFullfillmentTypeDelivery = function (changes) {
    let fullfillmentTypeDeliveryFlag = client.variation(
      FF_FULFILLMENT_TYPE_DELIVERY,
      true
    );
    let baseUrl = window.location.origin + "/";
    let languageCode = $("#scLanguageCode").val();
    let deliveryLocatorPageUrl = baseUrl + languageCode + "/deliverylocator";
    let locatorPageUrl = baseUrl + languageCode + "/locator";
    const pickupSelectButton = document.querySelector(".pickupSelectButton");

    if (!fullfillmentTypeDeliveryFlag) {
      $(".deliverySelectButton").hide();
      pickupSelectButton.style.setProperty("width", "100%", "important");
      if (window.location.href == deliveryLocatorPageUrl)
        location.assign(locatorPageUrl);
    }
    else {
      $(".deliverySelectButton").show();
      pickupSelectButton.style.setProperty("width", "49%");
    }
  };

  // Check for Maintenance Page Flag --> [FF_MAINTENANCE_PAGE_REDIRECT]
  this.ShowMaintenancePage = function (changes) {
    let maintenancePageData = client.variation(
      FF_MAINTENANCE_PAGE_REDIRECT,
      false
    );
    let webDownFlag =
      maintenancePageData.bodyWebDown || maintenancePageData.footerWebDown;
    let channelsDownFlag =
      maintenancePageData.bodyChannelsDown ||
      maintenancePageData.footerChannelsDown;
    let forceCheckout = maintenancePageData.forceLogout;

    let baseUrl = window.location.origin + "/";
    let languageCode = $("#scLanguageCode").val();
    let maintenancePageUrl = `${baseUrl}maintenance.aspx?culture=${languageCode}&status=${webDownFlag ? "web" : "channels"
      }&forceCheckout=${forceCheckout ? maintenancePageData.forceLogout : false
      } `;

    // if the maintenance page flag is false (off) redirect user back homepage
    if (
      maintenancePageData.maintenancePageFlag === false &&
      window.location.pathname === "/maintenance.aspx"
    ) {
      if (languageCode === "" || languageCode === undefined)
        location.replace(baseUrl);
      else location.replace(baseUrl + languageCode);
    }

    // in the case that LD flag is changed from web to channels and vice versa while on maintenance page
    else if (window.location.pathname === "/maintenance.aspx" && changes) {
      maintenancePageUrl = `${baseUrl}maintenance.aspx?culture=${languageCode}&status=${webDownFlag ? "web" : "channels"
        }`;
      location.replace(maintenancePageUrl);
    }

    // redirect if user is not on maintenance page
    else if (
      (channelsDownFlag !== undefined || webDownFlag !== undefined) &&
      window.location.pathname !== "/maintenance.aspx"
    ) {
      location.replace(maintenancePageUrl);
    }

    // if user is on maintenance page fill in data from LD
    else if (
      (channelsDownFlag !== undefined || webDownFlag !== undefined) &&
      window.location.pathname === "/maintenance.aspx"
    ) {
      $(".maintenance-error__title").html(maintenancePageData.title);
      $(".maintenance-error__desc").html(
        channelsDownFlag !== undefined
          ? maintenancePageData.bodyChannelsDown
          : maintenancePageData.bodyWebDown
      );
      $(".maintenance-error__footer").html(
        channelsDownFlag !== undefined
          ? maintenancePageData.footerChannelsDown
          : maintenancePageData.footerWebDown
      );
    }
  };

  // Check for Show Favorites Flag --> [FF-SHOW-FAVORITES]
  this.HideFavorites = function (changes) {
    let favoritesFlag = client.variation(FF_SHOW_FAVORITES, false);
    if (favoritesFlag) {
      $("#my-favorites").show();
      $(".slider__favorite").show();
      $(
        "#homePageNew > main > div > div:nth-child(1) > div:nth-child(5) > a"
      ).show();
      if ($(".favorites-carousel").length) {
        $(".favorites-carousel").slick("unslick");
        SlickRender();
      }
    } else if (!favoritesFlag) {
      $("#my-favorites").hide();
      $(
        "#homePageNew > main > div > div:nth-child(1) > div:nth-child(5) > a"
      ).hide();
      $(".slider__favorite").hide();
    }
  };

  // Check for Vanity Code Enabled Flag --> [FF-VANITY-CODE-ENABLED]
  this.HideVanityCode = function (changes) {
    let vanityCodeEnabledFlag = client.variation(FF_VANITY_CODE_ENABLED, false);
    if (vanityCodeEnabledFlag) {
      $(".order-summary__promoCode").show();
      $(".order-summary__offerDisclaimer").show();
    } else if (!vanityCodeEnabledFlag) {
      $(".order-summary__promoCode").css("display", "none");
      $(".order-summary__offerDisclaimer").css("display", "none");
    }
  };

  // Check for Show Best Sellers Flag --> [Hide_Best_Sellers]
  this.HideBestSellers = function (changes) {
    let hideBestSellersFlag = client.variation(FF_BEST_SELLERS_ENABLED, false);
    if (hideBestSellersFlag) {
      $("#display_tabs > div > a:last-child").show();
      $(".slider__bestseller").show();
      if (
        $("#my-favorites").is(":visible") === false ||
        $("#Favorites").children()[0] === undefined
      ) {
        $("#BestSeller").show();
        if ($(".favorites-carousel").length) {
          $(".favorites-carousel").slick("unslick");
          SlickRender();
        }
      }
    } else if (!hideBestSellersFlag) {
      $("#BestSeller").hide();
      $("#display_tabs > div > a:last-child").hide();
      $(".slider__bestseller").hide();
    }
  };

  // Check for Custom Banner Flag --> [FF_ENABLE_CUSTOM_BANNER]
  this.ShowCustomBanner = function (changes) {
    // see if user is logged in
    let userLoggedInFlag =
      JSON.parse(
        ("; " + document.cookie)
          .split(`; UserProfileCacheKey=`)
          .pop()
          .split(";")[0]
      ).isLoggedIn || false;
    if (!userLoggedInFlag) return;

    // see if user is on homepage / profile / cart page
    let urlRegexArray = [
      /order-management/gi,
      /profile/gi,
      /[A-Za-z]{2}-[A-Za-z]{2}/g,
    ];
    let endOfUrl =
      window.location.pathname.split("/").pop() ||
      window.location.pathname.split("/")[1];
    let isMatch = urlRegexArray.some(function (rx) {
      return rx.test(endOfUrl);
    });
    if (!isMatch) return;

    let showCustomBannerData = client.variation(FF_ENABLE_CUSTOM_BANNER, false);
    // check if session storage value exists
    let customBannerSessionValue = sessionStorage.getItem("showFlag");
    if (!customBannerSessionValue) sessionStorage.setItem("showFlag", "true");

    let showBannerFlag =
      showCustomBannerData && showCustomBannerData.bannerFlag
        ? showCustomBannerData.bannerFlag
        : false;

    // if flag is true show banner
    if (showBannerFlag && customBannerSessionValue === "true") {
      if ($("nav").hasClass("cms")) {
        var cmsMarginTop = $(".cms .navbar").height() || 0;
        $(".cms .nav_padding").css({ "padding-top": `${cmsMarginTop}px` });
        $(".cms .defaultStoreHeader").css({ top: `${cmsMarginTop}px` });
        $(".dashboard-banner").css("margin-top", `${cmsMarginTop}px`);
      }
      $(".dashboard-banner").css(
        "background-color",
        showCustomBannerData.backgroundColor || "#CF0000"
      );
      $(".dashboard-banner__inner--text").css(
        "color",
        showCustomBannerData.textColor || "#FFF"
      );
      $(".dashboard-banner__inner--text").html(
        showCustomBannerData.bannerMessage[
        $("#scLanguageCode").val().slice(-5, 2).toLowerCase() || "en"
        ] || "An error has occurred"
      );
      $(".dashboard-banner").attr("hidden", false);
    } else if (!showBannerFlag || customBannerSessionValue === "false") {
      $(".dashboard-banner").attr("hidden", true);
    }
  };

  $(".dashboard-banner__inner--close").click(() => {
    $(".dashboard-banner").attr("hidden", true);
    sessionStorage.setItem("showFlag", "false");
  });

  // Check for Show Rewards and Deals Flag --> [FF_LOYALTY_MIGRATION]
  this.HideRewardsAndDeals = function (changes) {
    let hideRewardsAndDeals = client.variation(FF_LOYALTY_MIGRATION, false);
    if (hideRewardsAndDeals) {
      $(".in-Rewards-View").parent().hide();
      $(".earn-while-you-eat-w").parent().hide();
      $(".rewards-tracker-progress-div").parent().parent().hide();
      $(".deals").parent().hide();
      $(".row.mbRewardLnk").parent().hide();
      if (window.location.pathname.split("/").pop() == "profile") {
        //$(".rewardsArea").hide();
        $("#Rewards").hide();
      }
    } else if (!hideRewardsAndDeals) {
      $(".in-Rewards-View").parent().show();
      $(".earn-while-you-eat-w").parent().show();
      $(".rewards-tracker-progress-div").parent().parent().show();
      $(".deals").parent().show();
      if (window.location.pathname.split("/").pop() == "profile") {
        //$(".rewardsArea").show();
        $("#Rewards").show();
        $(".row.mbRewardLnk").parent().show();
      }
    }
  };
};

if (window.LDClient) {
  InitilizeLD();
  launchdarkly = new LaunchDarkly();
}
